import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react";

export default function Testimonials({ items = [] }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((v) => (v + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;
  const t = items[i];

  return (
    <section className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-40" data-testid="testimonials-section">
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-white/40 mb-14 flex items-center gap-3">
        <span className="w-8 h-px bg-[color:var(--accent)]" /> Words from clients
      </p>

      <div className="relative min-h-[280px] md:min-h-[240px]">
        <Quote size={80} className="text-white/5 absolute -top-6 -left-2 pointer-events-none" />
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={t.id}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="relative"
            data-testid="testimonial-quote"
          >
            <p className="font-display text-3xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-5xl">
              "{t.quote}"
            </p>
            <footer className="mt-10 font-mono text-sm">
              <span className="text-white">{t.name}</span>
              <span className="text-white/40"> — {t.role}</span>
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>

      <div className="flex gap-2 mt-12">
        {items.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setI(idx)}
            className={`h-1 transition-all ${idx === i ? "w-12 bg-[color:var(--accent)]" : "w-6 bg-white/20 hover:bg-white/40"}`}
            data-testid={`testimonial-dot-${idx}`}
            aria-label={`Testimonial ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
